import { SVGProps } from 'react';

const ArrowRightToLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 12H3m8-6 6 6-6 6M21 5v14"
    />
  </svg>
);
export default ArrowRightToLine;
